import styled from "styled-components"

export const StyledHugeLikeButton = styled.button`
  width: 100%;
  border: 1px solid #c4b180;
  background: rgba(196, 177, 128, 0.1);
  padding: 16px 32px;
  color: #86723e;
  text-align: center;
  font-family: Nunito Sans;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.9px;
  cursor: pointer;

  &:hover {
    background: rgba(196, 177, 128, 0.3);
  }

  &:active {
    background: rgba(196, 177, 128, 0.4);
  }
`


